import accountPageRoutes from './account';

const Login = () => import('@component/user-backend/Login.vue');
const PasswordResetRequest = () =>
	import('@component/user-backend/PasswordResetRequest.vue');
const PasswordReset = () => import('@component/user-backend/PasswordReset.vue');
const Cart = () => import('@component/user-backend/Cart/Cart.vue');
const Checkout = () => import('@component/user-backend/Checkout/Checkout.vue');
const CheckoutV2 = () =>
	import('@component/user-backend/Checkout/V2/Checkout.vue');
const CheckoutVS = () =>
	import('@component/user-backend/Checkout/VS/Checkout.vue');
const CheckoutV4 = () =>
	import('@component/user-backend/Checkout/V4/Checkout.vue');

const routes = [
	{
		path: '/login',
		name: 'login',
		component: Login,
		meta: {
			title: 'Sculptnation - Login',
		},
	},

	{
		path: '/password/reset',
		name: 'password-reset-request',
		component: PasswordResetRequest,
		meta: {
			title: 'Sculptnation - Reset Password',
		},
	},

	{
		path: '/password/reset/:token',
		name: 'password-reset',
		component: PasswordReset,
		meta: {
			title: 'Sculptnation - Reset Password',
		},
	},

	{
		path: '/cart',
		name: 'cart',
		component: Cart,
		meta: {
			title: 'Sculptnation - Cart',
		},
	},

	{
		path: '/checkout/:offers?',
		name: 'checkout',
		component: Checkout,
		meta: {
			title: 'Sculptnation - Checkout',
		},
	},

	{
		path: '/checkout-v2/:offers?',
		name: 'checkout-v2',
		component: CheckoutV2,
		meta: {
			title: 'Sculptnation - Checkout V2',
		},
	},

	{
		path: '/checkout-vst/:offers?',
		name: 'checkout-vst',
		component: Checkout,
		meta: {
			title: 'Sculptnation - Checkout',
		},
	},

	{
		path: '/checkout-vs/:offers?',
		name: 'checkout-vs',
		component: CheckoutVS,
		meta: {
			title: 'VShred - Checkout',
		},
	},

	{
		path: '/checkout-v4/:offers?',
		name: 'checkout-v4',
		component: CheckoutV4,
		meta: {
			title: 'Sculptnation - Checkout',
		},
	},

	{
		path: '/discount-checkout/:discount',
		name: 'discount-checkout',
		component: CheckoutV4,
		meta: {
			title: 'Sculptnation - Checkout',
		},
	},

	accountPageRoutes,
];

export default routes;
